<template>
    <v-menu
        v-model="open"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        dense
        elevation="0"
        :solo="solo"
        :filled="filled"
        
        
    >
        <template v-slot:activator="{ on, attrs }">
        <v-text-field
            :value="DisplayValue"
            outlined
            v-bind="attrs"
            v-on="on"
            dense
            hide-details
            :solo="solo"
            :filled="filled"
            :label="label"
            elevation="0"
            class="custom-date-selector"
            @change="($event)=>{callback($event)}"
        ></v-text-field>
        </template>
        <v-date-picker :value="formattedValue" no-title @input="($event)=>{callback($event)}"></v-date-picker>
    </v-menu>
</template>

<script>
import { mapState } from 'vuex'
  export default {
    name: 'Main',
    props: ['bindTo','label','callback','solo','filled'],
    
    // components: {
    //   Row
    // },
    data: () => ({
        open:false
    }),
    computed: {
        formattedValue(){
            if(!this.bindTo){
                return undefined
            }
            return this.moment(this.bindTo).format('YYYY-MM-DD')
        },
        DisplayValue(){
            if(!this.bindTo){
                return undefined
            }
            return this.moment(this.bindTo).format('MM/DD/YY')
        },
        
        ...mapState(['moment'])
    }
  }
</script>

<style>

</style>